// Display-only omission requested by the user. Published text stays intact in
// the catalog, search index and local record copies; other markers are retained.
export function displayDescription(text:string):string {
  return text.replace(/[ \t]*\(\+ possibile\)/g,'');
}
